import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import api from '../utils/api';
import { Button } from '../components/ui/button';

const OUTCOME = { ok: 'text-green-400', denied: 'text-red-400', failed: 'text-yellow-400' };

export const AuditLogPanel = () => {
  const [rows, setRows] = useState([]);
  const [action, setAction] = useState('');

  const load = () => api.get('/admin/security/audit', { params: { limit: 200, action: action || undefined } })
    .then((r) => setRows(r.data)).catch(() => toast.error('No se pudo cargar la auditoría'));
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4" data-testid="audit-log-panel">
      <div className="flex gap-2">
        <input placeholder="Filtrar por acción (p. ej. kyc., admin., access.denied)" value={action}
          onChange={(e) => setAction(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && load()}
          className="flex-1 bg-gray-900 border border-gray-800 rounded-lg px-3 py-2 text-white text-sm" data-testid="audit-filter" />
        <Button variant="ghost" onClick={load} data-testid="audit-refresh"><RefreshCw className="w-4 h-4" /></Button>
      </div>
      <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-800 text-xs text-gray-400 uppercase">
            <tr><th className="px-3 py-2 text-left">Fecha</th><th className="px-3 py-2 text-left">Actor</th>
              <th className="px-3 py-2 text-left">Acción</th><th className="px-3 py-2 text-left">Objetivo</th>
              <th className="px-3 py-2 text-left">Motivo / detalle</th></tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <td className="px-3 py-2 text-gray-500 whitespace-nowrap">{new Date(r.at).toLocaleString('es-PE')}</td>
                <td className="px-3 py-2 text-gray-300">{r.actor_email || '—'}<span className="block text-xs text-gray-500">{r.actor_role}</span></td>
                <td className={`px-3 py-2 font-mono text-xs ${OUTCOME[r.outcome]}`}>{r.action}</td>
                <td className="px-3 py-2 text-gray-400 text-xs">{r.target_type ? `${r.target_type}: ${r.target_id}` : '—'}</td>
                <td className="px-3 py-2 text-gray-400 text-xs max-w-md break-words">
                  {r.reason}{r.details && Object.keys(r.details).length > 0 && <span className="block text-gray-600">{JSON.stringify(r.details).slice(0, 200)}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-gray-500">Registro protegido: solo admite inserciones (la base de datos rechaza ediciones y borrados).</p>
    </div>
  );
};

export default AuditLogPanel;
